var _g, _g2, _g3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumingWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 120,
    viewBox: "0 0 259 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddii_2311_118)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1217 24.1169C87.1217 21.9077 85.3308 20.1169 83.1217 20.1169H72.2437C70.0346 20.1169 68.2437 21.9077 68.2437 24.1169V46.318C68.2437 48.5272 66.4529 50.318 64.2437 50.318H42.878C40.6688 50.318 38.878 48.5272 38.878 46.318V23.6713C38.878 21.5524 37.2215 19.8167 35.1119 20.0147C29.6043 20.5315 20 22.8926 20 33.0759V93.2049C20 95.414 21.7909 97.2122 24 97.2122H34.878C37.0871 97.2122 38.878 95.4213 38.878 93.2122V68.662C38.878 66.7964 40.1676 65.1786 41.9862 64.7627L44.8326 64.1118C46.8863 63.6421 49.0824 64.81 50.2039 66.5933C51.2927 68.3245 53.031 70.7334 55.7688 73.82C59.0273 77.4937 62.2876 79.3673 64.6575 80.3189C66.6065 81.1014 68.2437 82.9161 68.2437 85.0163V93.2122C68.2437 95.4213 70.0346 97.2122 72.2437 97.2122H83.1217C85.3308 97.2122 87.1217 95.4213 87.1217 93.2122V80.4123C85.5027 80.0496 83.7674 79.8236 81.912 79.7685C64.2665 79.244 59.1199 76.7269 51.2425 62.8826C50.5072 61.2744 44.2893 57.4078 25.2994 54.8067C29.4657 54.8417 39.8779 55.7297 48.1965 59.002C48.6867 59.1768 49.856 59.3586 50.6123 58.6873C50.8514 58.4751 51.1242 58.0748 51.451 57.5953C52.4159 56.1795 53.8518 54.0726 56.284 54.0726C59.54 54.0726 61.8508 55.9604 62.7961 59.4215C65.772 59.841 72.7952 60.0718 77.0805 57.6385C79.5868 56.2155 83.4036 53.7363 87.1217 50.7166V24.1169ZM87.1217 60.2854C84.7355 62.8242 81.839 65.313 78.3409 67.6022C75.9602 68.7909 73.3413 71.6087 81.912 73.3707C83.3765 73.7885 85.1765 74.4446 87.1217 75.3453V60.2854ZM72.354 57.6385C70.7277 57.9182 66.9593 58.4356 64.8967 58.2678C67.3825 53.4433 73.4254 42.9342 77.7107 39.4941C76.6691 41.7909 74.9579 46.051 73.7471 50.2968C73.0043 52.9016 72.4499 55.5011 72.354 57.6385Z",
    fill: "#F3F5F8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2311_118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3401 66.118C87.6353 64.1036 95.7307 47.2329 97.3665 39.0493C97.2273 44.505 93.2527 57.8505 78.468 67.5868C76.1014 68.7759 73.498 71.5947 82.018 73.3573C70.8251 73.6091 68.2357 68.636 68.3401 66.118Z",
    fill: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.736 111.337C107.745 101.937 102.552 92.8719 99.4547 89.5146C101.794 95.1381 100.012 100.041 98.8283 101.79L101.282 106.564L103.736 111.337Z",
    fill: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7901 58.2028C66.8405 58.3706 70.8998 57.8995 72.5166 57.6197C72.6119 55.4815 73.163 52.8812 73.9014 50.2755C72.5697 52.129 68.6325 56.2723 64.7901 58.2028Z",
    fill: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7528 57.268C82.3304 54.7753 93.8165 46.7083 97.3665 39.0493M97.3665 39.0493C95.7307 47.2329 87.6353 64.1036 68.3401 66.118C68.2357 68.636 70.8251 73.6091 82.018 73.3573M97.3665 39.0493C97.2273 44.505 93.2527 57.8505 78.468 67.5868C76.1014 68.7759 73.498 71.5947 82.018 73.3573M82.018 73.3573C88.8396 75.3158 102.984 82.5061 104.989 95.5998C103.179 90.4938 95.1723 80.0138 82.0172 80.0138M99.4547 89.5146C102.552 92.8719 107.745 101.937 103.736 111.337L101.282 106.564M99.4547 89.5146C101.794 95.1381 100.012 100.041 98.8283 101.79L101.282 106.564M99.4547 89.5146C101.195 92.802 103.997 100.814 101.282 106.564M72.5166 57.6197C70.8998 57.8995 66.8405 58.3706 64.7901 58.2028C68.6325 56.2723 72.5697 52.129 73.9014 50.2755C73.163 52.8812 72.6119 55.4815 72.5166 57.6197Z",
    stroke: "#F3F5F8",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddii_2311_118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.869 53.1626V76.4991H114.528V73.3206C113.784 74.3522 112.768 75.1887 111.48 75.8299C110.221 76.4433 108.818 76.75 107.273 76.75C105.441 76.75 103.824 76.3597 102.422 75.579C101.019 74.7704 99.9318 73.6134 99.1591 72.1078C98.3864 70.6022 98 68.8318 98 66.7965V53.1626H105.298V65.8346C105.298 67.3959 105.713 68.6087 106.543 69.473C107.373 70.3374 108.489 70.7695 109.891 70.7695C111.322 70.7695 112.453 70.3374 113.283 69.473C114.113 68.6087 114.528 67.3959 114.528 65.8346V53.1626H121.869Z",
    fill: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.707 52.9117C160.684 52.9117 163.045 53.79 164.791 55.5465C166.565 57.303 167.452 59.7426 167.452 62.8652V76.4991H160.154V63.8271C160.154 62.3216 159.739 61.1645 158.909 60.3559C158.108 59.5195 156.992 59.1013 155.561 59.1013C154.13 59.1013 152.999 59.5195 152.169 60.3559C151.368 61.1645 150.967 62.3216 150.967 63.8271V76.4991H143.669V63.8271C143.669 62.3216 143.254 61.1645 142.425 60.3559C141.623 59.5195 140.507 59.1013 139.076 59.1013C137.645 59.1013 136.515 59.5195 135.685 60.3559C134.883 61.1645 134.483 62.3216 134.483 63.8271V76.4991H127.142V53.1626H134.483V56.0901C135.227 55.1143 136.2 54.3476 137.402 53.79C138.604 53.2045 139.963 52.9117 141.48 52.9117C143.283 52.9117 144.886 53.2881 146.288 54.0409C147.719 54.7937 148.835 55.8671 149.637 57.2612C150.467 55.9786 151.597 54.9331 153.028 54.1245C154.459 53.316 156.019 52.9117 157.707 52.9117Z",
    fill: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.278 50.737C174.99 50.737 173.932 50.3745 173.102 49.6496C172.3 48.8968 171.9 47.9768 171.9 46.8894C171.9 45.7742 172.3 44.8541 173.102 44.1292C173.932 43.3764 174.99 43 176.278 43C177.538 43 178.568 43.3764 179.369 44.1292C180.199 44.8541 180.614 45.7742 180.614 46.8894C180.614 47.9768 180.199 48.8968 179.369 49.6496C178.568 50.3745 177.538 50.737 176.278 50.737ZM179.927 53.1626V76.4991H172.586V53.1626H179.927Z",
    fill: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.843 52.9117C202.648 52.9117 204.88 53.8039 206.54 55.5883C208.229 57.3448 209.073 59.7704 209.073 62.8652V76.4991H201.775V63.8271C201.775 62.2658 201.36 61.053 200.53 60.1887C199.7 59.3244 198.584 58.8922 197.182 58.8922C195.779 58.8922 194.663 59.3244 193.833 60.1887C193.003 61.053 192.588 62.2658 192.588 63.8271V76.4991H185.247V53.1626H192.588V56.2574C193.332 55.2258 194.334 54.4173 195.593 53.8318C196.852 53.2184 198.269 52.9117 199.843 52.9117Z",
    fill: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.869 53.1626V76.4991H114.528V73.3206C113.784 74.3522 112.768 75.1887 111.48 75.8299C110.221 76.4433 108.818 76.75 107.273 76.75C105.441 76.75 103.824 76.3597 102.422 75.579C101.019 74.7704 99.9318 73.6134 99.1591 72.1078C98.3864 70.6022 98 68.8318 98 66.7965V53.1626H105.298V65.8346C105.298 67.3959 105.713 68.6087 106.543 69.473C107.373 70.3374 108.489 70.7695 109.891 70.7695C111.322 70.7695 112.453 70.3374 113.283 69.473C114.113 68.6087 114.528 67.3959 114.528 65.8346V53.1626H121.869Z",
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.869 53.1626V76.4991H114.528V73.3206C113.784 74.3522 112.768 75.1887 111.48 75.8299C110.221 76.4433 108.818 76.75 107.273 76.75C105.441 76.75 103.824 76.3597 102.422 75.579C101.019 74.7704 99.9318 73.6134 99.1591 72.1078C98.3864 70.6022 98 68.8318 98 66.7965V53.1626H105.298V65.8346C105.298 67.3959 105.713 68.6087 106.543 69.473C107.373 70.3374 108.489 70.7695 109.891 70.7695C111.322 70.7695 112.453 70.3374 113.283 69.473C114.113 68.6087 114.528 67.3959 114.528 65.8346V53.1626H121.869Z",
    stroke: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.707 52.9117C160.684 52.9117 163.045 53.79 164.791 55.5465C166.565 57.303 167.452 59.7426 167.452 62.8652V76.4991H160.154V63.8271C160.154 62.3216 159.739 61.1645 158.909 60.3559C158.108 59.5195 156.992 59.1013 155.561 59.1013C154.13 59.1013 152.999 59.5195 152.169 60.3559C151.368 61.1645 150.967 62.3216 150.967 63.8271V76.4991H143.669V63.8271C143.669 62.3216 143.254 61.1645 142.425 60.3559C141.623 59.5195 140.507 59.1013 139.076 59.1013C137.645 59.1013 136.515 59.5195 135.685 60.3559C134.883 61.1645 134.483 62.3216 134.483 63.8271V76.4991H127.142V53.1626H134.483V56.0901C135.227 55.1143 136.2 54.3476 137.402 53.79C138.604 53.2045 139.963 52.9117 141.48 52.9117C143.283 52.9117 144.886 53.2881 146.288 54.0409C147.719 54.7937 148.835 55.8671 149.637 57.2612C150.467 55.9786 151.597 54.9331 153.028 54.1245C154.459 53.316 156.019 52.9117 157.707 52.9117Z",
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.707 52.9117C160.684 52.9117 163.045 53.79 164.791 55.5465C166.565 57.303 167.452 59.7426 167.452 62.8652V76.4991H160.154V63.8271C160.154 62.3216 159.739 61.1645 158.909 60.3559C158.108 59.5195 156.992 59.1013 155.561 59.1013C154.13 59.1013 152.999 59.5195 152.169 60.3559C151.368 61.1645 150.967 62.3216 150.967 63.8271V76.4991H143.669V63.8271C143.669 62.3216 143.254 61.1645 142.425 60.3559C141.623 59.5195 140.507 59.1013 139.076 59.1013C137.645 59.1013 136.515 59.5195 135.685 60.3559C134.883 61.1645 134.483 62.3216 134.483 63.8271V76.4991H127.142V53.1626H134.483V56.0901C135.227 55.1143 136.2 54.3476 137.402 53.79C138.604 53.2045 139.963 52.9117 141.48 52.9117C143.283 52.9117 144.886 53.2881 146.288 54.0409C147.719 54.7937 148.835 55.8671 149.637 57.2612C150.467 55.9786 151.597 54.9331 153.028 54.1245C154.459 53.316 156.019 52.9117 157.707 52.9117Z",
    stroke: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.278 50.737C174.99 50.737 173.932 50.3745 173.102 49.6496C172.3 48.8968 171.9 47.9768 171.9 46.8894C171.9 45.7742 172.3 44.8541 173.102 44.1292C173.932 43.3764 174.99 43 176.278 43C177.538 43 178.568 43.3764 179.369 44.1292C180.199 44.8541 180.614 45.7742 180.614 46.8894C180.614 47.9768 180.199 48.8968 179.369 49.6496C178.568 50.3745 177.538 50.737 176.278 50.737ZM179.927 53.1626V76.4991H172.586V53.1626H179.927Z",
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.278 50.737C174.99 50.737 173.932 50.3745 173.102 49.6496C172.3 48.8968 171.9 47.9768 171.9 46.8894C171.9 45.7742 172.3 44.8541 173.102 44.1292C173.932 43.3764 174.99 43 176.278 43C177.538 43 178.568 43.3764 179.369 44.1292C180.199 44.8541 180.614 45.7742 180.614 46.8894C180.614 47.9768 180.199 48.8968 179.369 49.6496C178.568 50.3745 177.538 50.737 176.278 50.737ZM179.927 53.1626V76.4991H172.586V53.1626H179.927Z",
    stroke: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.843 52.9117C202.648 52.9117 204.88 53.8039 206.54 55.5883C208.229 57.3448 209.073 59.7704 209.073 62.8652V76.4991H201.775V63.8271C201.775 62.2658 201.36 61.053 200.53 60.1887C199.7 59.3244 198.584 58.8922 197.182 58.8922C195.779 58.8922 194.663 59.3244 193.833 60.1887C193.003 61.053 192.588 62.2658 192.588 63.8271V76.4991H185.247V53.1626H192.588V56.2574C193.332 55.2258 194.334 54.4173 195.593 53.8318C196.852 53.2184 198.269 52.9117 199.843 52.9117Z",
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.843 52.9117C202.648 52.9117 204.88 53.8039 206.54 55.5883C208.229 57.3448 209.073 59.7704 209.073 62.8652V76.4991H201.775V63.8271C201.775 62.2658 201.36 61.053 200.53 60.1887C199.7 59.3244 198.584 58.8922 197.182 58.8922C195.779 58.8922 194.663 59.3244 193.833 60.1887C193.003 61.053 192.588 62.2658 192.588 63.8271V76.4991H185.247V53.1626H192.588V56.2574C193.332 55.2258 194.334 54.4173 195.593 53.8318C196.852 53.2184 198.269 52.9117 199.843 52.9117Z",
    stroke: "#F3F5F8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ddii_2311_118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.365 53C229.502 53 231.367 53.4185 232.961 54.2556C234.591 55.0927 235.84 56.1914 236.71 57.5517V53.4185H246V82.56C246 85.2457 245.439 87.6698 244.316 89.8323C243.229 92.0297 241.545 93.7737 239.263 95.0642C237.018 96.3547 234.211 97 230.842 97C226.351 97 222.711 95.9711 219.922 93.9132C217.133 91.8902 215.539 89.1348 215.141 85.6469H224.323C224.612 86.763 225.301 87.635 226.387 88.2628C227.474 88.9255 228.814 89.2568 230.407 89.2568C232.327 89.2568 233.848 88.7162 234.971 87.635C236.13 86.5886 236.71 84.8969 236.71 82.56V78.4269C235.804 79.7872 234.555 80.9033 232.961 81.7753C231.367 82.6124 229.502 83.0309 227.365 83.0309C224.866 83.0309 222.602 82.4205 220.574 81.1998C218.546 79.9441 216.934 78.1827 215.739 75.9156C214.58 73.6136 214 70.9627 214 67.9631C214 64.9635 214.58 62.3302 215.739 60.063C216.934 57.7959 218.546 56.0519 220.574 54.8312C222.602 53.6104 224.866 53 227.365 53ZM236.71 68.0155C236.71 65.7832 236.058 64.0218 234.754 62.7313C233.486 61.4407 231.929 60.7955 230.081 60.7955C228.234 60.7955 226.659 61.4407 225.355 62.7313C224.087 63.9869 223.453 65.7309 223.453 67.9631C223.453 70.1954 224.087 71.9742 225.355 73.2996C226.659 74.5902 228.234 75.2354 230.081 75.2354C231.929 75.2354 233.486 74.5902 234.754 73.2996C236.058 72.0091 236.71 70.2477 236.71 68.0155Z",
    fill: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.365 53C229.502 53 231.367 53.4185 232.961 54.2556C234.591 55.0927 235.84 56.1914 236.71 57.5517V53.4185H246V82.56C246 85.2457 245.439 87.6698 244.316 89.8323C243.229 92.0297 241.545 93.7737 239.263 95.0642C237.018 96.3547 234.211 97 230.842 97C226.351 97 222.711 95.9711 219.922 93.9132C217.133 91.8902 215.539 89.1348 215.141 85.6469H224.323C224.612 86.763 225.301 87.635 226.387 88.2628C227.474 88.9255 228.814 89.2568 230.407 89.2568C232.327 89.2568 233.848 88.7162 234.971 87.635C236.13 86.5886 236.71 84.8969 236.71 82.56V78.4269C235.804 79.7872 234.555 80.9033 232.961 81.7753C231.367 82.6124 229.502 83.0309 227.365 83.0309C224.866 83.0309 222.602 82.4205 220.574 81.1998C218.546 79.9441 216.934 78.1827 215.739 75.9156C214.58 73.6136 214 70.9627 214 67.9631C214 64.9635 214.58 62.3302 215.739 60.063C216.934 57.7959 218.546 56.0519 220.574 54.8312C222.602 53.6104 224.866 53 227.365 53ZM236.71 68.0155C236.71 65.7832 236.058 64.0218 234.754 62.7313C233.486 61.4407 231.929 60.7955 230.081 60.7955C228.234 60.7955 226.659 61.4407 225.355 62.7313C224.087 63.9869 223.453 65.7309 223.453 67.9631C223.453 70.1954 224.087 71.9742 225.355 73.2996C226.659 74.5902 228.234 75.2354 230.081 75.2354C231.929 75.2354 233.486 74.5902 234.754 73.2996C236.058 72.0091 236.71 70.2477 236.71 68.0155Z",
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.365 53C229.502 53 231.367 53.4185 232.961 54.2556C234.591 55.0927 235.84 56.1914 236.71 57.5517V53.4185H246V82.56C246 85.2457 245.439 87.6698 244.316 89.8323C243.229 92.0297 241.545 93.7737 239.263 95.0642C237.018 96.3547 234.211 97 230.842 97C226.351 97 222.711 95.9711 219.922 93.9132C217.133 91.8902 215.539 89.1348 215.141 85.6469H224.323C224.612 86.763 225.301 87.635 226.387 88.2628C227.474 88.9255 228.814 89.2568 230.407 89.2568C232.327 89.2568 233.848 88.7162 234.971 87.635C236.13 86.5886 236.71 84.8969 236.71 82.56V78.4269C235.804 79.7872 234.555 80.9033 232.961 81.7753C231.367 82.6124 229.502 83.0309 227.365 83.0309C224.866 83.0309 222.602 82.4205 220.574 81.1998C218.546 79.9441 216.934 78.1827 215.739 75.9156C214.58 73.6136 214 70.9627 214 67.9631C214 64.9635 214.58 62.3302 215.739 60.063C216.934 57.7959 218.546 56.0519 220.574 54.8312C222.602 53.6104 224.866 53 227.365 53ZM236.71 68.0155C236.71 65.7832 236.058 64.0218 234.754 62.7313C233.486 61.4407 231.929 60.7955 230.081 60.7955C228.234 60.7955 226.659 61.4407 225.355 62.7313C224.087 63.9869 223.453 65.7309 223.453 67.9631C223.453 70.1954 224.087 71.9742 225.355 73.2996C226.659 74.5902 228.234 75.2354 230.081 75.2354C231.929 75.2354 233.486 74.5902 234.754 73.2996C236.058 72.0091 236.71 70.2477 236.71 68.0155Z",
    stroke: "#F3F5F8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ddii_2311_118)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 83,
    width: 103,
    height: 2,
    rx: 1,
    fill: "#FDFEFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.5,
    y: 83.5,
    width: 102,
    height: 1,
    rx: 0.5,
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.5,
    y: 83.5,
    width: 102,
    height: 1,
    rx: 0.5,
    stroke: "#F3F5F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddii_2311_118",
    x: 0,
    y: -0.000732422,
    width: 99.1221,
    height: 109.213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.259514 0 0 0 0 0.324042 0 0 0 0 0.420833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2311_118"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2311_118",
    result: "effect2_dropShadow_2311_118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2311_118",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.32549 0 0 0 0 0.419608 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2311_118"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_2311_118",
    result: "effect4_innerShadow_2311_118"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2311_118",
    x: 60.54,
    y: 38.7993,
    width: 48.9053,
    height: 80.7881,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2311_118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2311_118",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddii_2311_118",
    x: 77.5,
    y: 22.5,
    width: 144.073,
    height: 66.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.259514 0 0 0 0 0.324042 0 0 0 0 0.420833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2311_118"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2311_118",
    result: "effect2_dropShadow_2311_118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2311_118",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.32549 0 0 0 0 0.419608 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2311_118"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_2311_118",
    result: "effect4_innerShadow_2311_118"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ddii_2311_118",
    x: 193.5,
    y: 32.5,
    width: 65,
    height: 77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.259514 0 0 0 0 0.324042 0 0 0 0 0.420833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2311_118"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2311_118",
    result: "effect2_dropShadow_2311_118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2311_118",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.32549 0 0 0 0 0.419608 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2311_118"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_2311_118",
    result: "effect4_innerShadow_2311_118"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ddii_2311_118",
    x: 87,
    y: 63,
    width: 135,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.259514 0 0 0 0 0.324042 0 0 0 0 0.420833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2311_118"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2311_118",
    result: "effect2_dropShadow_2311_118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2311_118",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.32549 0 0 0 0 0.419608 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2311_118"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_2311_118",
    result: "effect4_innerShadow_2311_118"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumingWhiteLogo);
export default __webpack_public_path__ + "static/media/HumingWhiteLogo.f6ed17e1873a76e7c2d22931b523ecef.svg";
export { ForwardRef as ReactComponent };